import React from 'react';

const Logo = ({
  id,
  className,
  size = 79,
}: {
  id?: string;
  className?: string;
  size?: number;
}) => {
  const height = (size / 79) * 44;

  return (
    <svg
      width={size}
      height={height}
      viewBox="0 0 79 44"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      id={id}
      className={`text-[#090909] dark:text-[#E7E7E7] ${className || ''}`}
    >
      <g clipPath="url(#clip0_163_8555)">
        <path
          d="M67.1798 0V7.91492H59.2649V11.8193H67.1798V19.7342H71.0852V11.8193H79.0001V7.91492H71.0852V0H67.1798Z"
          fill="#FD9FFD"
        />
        <path
          d="M62.3771 16.8941C60.2298 14.7472 57.35 13.4919 54.3156 13.3801C51.2813 13.2683 48.3169 14.3083 46.0175 16.2914L45.9919 16.2668L45.3655 16.8922L42.8731 19.3846L42.8608 19.3713L36.6792 25.553C36.5962 25.6361 36.4977 25.7021 36.3893 25.7471C36.2808 25.7921 36.1645 25.8153 36.0471 25.8153C35.9296 25.8153 35.8134 25.7921 35.7049 25.7471C35.5964 25.7021 35.4979 25.6361 35.415 25.553L31.4916 21.6296L35.1515 17.9697L35.0738 17.893L30.7364 13.5555L30.7221 13.5413L27.0632 17.2012L23.0593 13.1973L18.7218 17.5357L22.7248 21.5386L18.2385 26.0296C18.0667 26.1411 17.862 26.1903 17.6583 26.1691C17.4547 26.1479 17.2644 26.0575 17.1193 25.9131L4.76079 13.5574L0.422363 17.8949L13.3959 30.8684L4.6935 39.5718L9.12195 44.0002L27.1523 25.9661L31.7087 30.5225L33.5206 32.3345C34.1904 33.0042 35.0989 33.3805 36.0461 33.3805C36.9934 33.3805 37.9018 33.0042 38.5717 32.3345L40.3836 30.5225L46.2895 24.6176L58.9787 37.305L63.0044 33.2783L62.9788 33.2537C64.9621 30.9544 66.0022 27.9901 65.8906 24.9557C65.779 21.9214 64.5238 19.0415 62.3771 16.8941ZM58.6177 28.8916L50.3787 20.6535C51.5134 19.8165 52.9107 19.4143 54.3168 19.5198C55.7229 19.6254 57.0445 20.2317 58.0416 21.2287C59.0387 22.2257 59.6452 23.5472 59.7509 24.9533C59.8566 26.3594 59.4545 27.7567 58.6177 28.8916Z"
          fill="currentColor"
        />
        <path
          d="M45.6744 35.2845H27.1504V38.5673H45.6744V35.2845Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0_163_8555">
          <rect
            width="78.5777"
            height="44.0002"
            fill="white"
            transform="translate(0.422363)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default Logo;
